var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "928C4879-9F52-4A67-9D67-1A1296F2AD39") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Homepage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomepageOK-1080px",
    transform: "translate(-904.000000, -5928.000000)",
    fill: "#FDC609",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bandeau-boost",
    transform: "translate(0.000000, 5602.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(854.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "divers",
    transform: "translate(0.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "001-layout",
    transform: "translate(50.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92307692,22.6068376 L20.8547009,22.6068376 C21.8376068,22.6068376 22.6068376,21.8376068 22.6068376,20.8547009 L22.6068376,1.92307692 C22.6068376,0.94017094 21.8376068,0.170940171 20.8547009,0.170940171 L1.92307692,0.170940171 C0.94017094,0.170940171 0.170940171,0.94017094 0.170940171,1.92307692 L0.170940171,20.8547009 C0.170940171,21.7948718 0.982905983,22.6068376 1.92307692,22.6068376 Z M3.67521368,3.67521368 L19.1025641,3.67521368 L19.1025641,19.1025641 L3.67521368,19.1025641 L3.67521368,3.67521368 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8290598,1.92307692 C49.8290598,0.94017094 49.0598291,0.170940171 48.0769231,0.170940171 L29.1452991,0.170940171 C28.1623932,0.170940171 27.3931624,0.94017094 27.3931624,1.92307692 L27.3931624,20.8547009 C27.3931624,21.8376068 28.1623932,22.6068376 29.1452991,22.6068376 L48.0769231,22.6068376 C49.0598291,22.6068376 49.8290598,21.8376068 49.8290598,20.8547009 L49.8290598,1.92307692 Z M46.3247863,19.1025641 L30.8974359,19.1025641 L30.8974359,3.67521368 L46.3247863,3.67521368 L46.3247863,19.1025641 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.92307692,49.8290598 L20.8547009,49.8290598 C21.8376068,49.8290598 22.6068376,49.0598291 22.6068376,48.0769231 L22.6068376,29.1452991 C22.6068376,28.1623932 21.8376068,27.3931624 20.8547009,27.3931624 L1.92307692,27.3931624 C0.94017094,27.3931624 0.170940171,28.1623932 0.170940171,29.1452991 L0.170940171,48.0769231 C0.170940171,49.017094 0.982905983,49.8290598 1.92307692,49.8290598 Z M3.67521368,30.8974359 L19.1025641,30.8974359 L19.1025641,46.3247863 L3.67521368,46.3247863 L3.67521368,30.8974359 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0769231,27.3931624 L29.1452991,27.3931624 C28.1623932,27.3931624 27.3931624,28.1623932 27.3931624,29.1452991 L27.3931624,48.0769231 C27.3931624,49.0598291 28.1623932,49.8290598 29.1452991,49.8290598 L48.0769231,49.8290598 C49.0598291,49.8290598 49.8290598,49.0598291 49.8290598,48.0769231 L49.8290598,29.1452991 C49.8290598,28.2051282 49.017094,27.3931624 48.0769231,27.3931624 Z M46.3247863,46.3247863 L30.8974359,46.3247863 L30.8974359,30.8974359 L46.3247863,30.8974359 L46.3247863,46.3247863 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout);
export default __webpack_public_path__ + "static/media/layout.ff2298f11e1128ea6f6550a15254d9d9.svg";
export { ForwardRef as ReactComponent };